import React from "react";
import styles from "./styles/Hero.module.css";
import img from "../../Assets/hero-img.png";
import { Link } from "react-router-dom";
function Hero() {
  return (
    <div className={`container ${styles.heroCont}`}>
      <div className={styles.hero}>
        <div className={styles.leftHero}>
          <h4>Realty Swap MarketPlace</h4>
          <h1>Register your Home on the BlockChain</h1>
          <p>
            NFT MarketPlace for Real Estate. Create a digital Asset for your
            property
          </p>
          <div className={styles.btnDiv}>
            <Link to="/Explore" className="cta-btn">
              Explore
            </Link>
            <Link to="/Create" className="cta-btn">
              Create
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
